import { graphql } from '@/__generated__';
import { useCacheMonitor } from '@/context/DiscoveryUrqlProvider';
import { useQueryStable } from '../useQueryStable';

export const GetExposureOwners = graphql(/* GraphQL */ `
  query GetExposureOwners($environmentId: BigInt!) {
    environment(id: $environmentId) {
      applied {
        lastUpdatedAt
        owners(resource: exposure) {
          name
        }
      }
    }
  }
`);

type OwnerProps = {
  environmentId: number | undefined;
  pause?: boolean;
};

export const useExposureOwners = ({ environmentId = 0, pause }: OwnerProps) => {
  const query = useQueryStable({
    query: GetExposureOwners,
    variables: { environmentId },
    pause: pause || !environmentId,
  });

  useCacheMonitor({ applied: query[0].data?.environment.applied?.lastUpdatedAt });

  return query;
};
